import { Box, Button, Tooltip } from '@mantine/core'

type CategoryChipProps = {
  label: string
  active?: boolean
  dotColor?: string
  /** Shown as a hover tooltip when present — the category's admin-authored
   * explanation of what it means. */
  description?: string | null
  /** Omit for a static display tag (e.g. a card's category label). */
  onClick?: () => void
}

/**
 * The pill used by CategoryFilter's chips — a label plus an optional
 * colour-dotted leftSection. Exported separately so any place that needs to
 * *show* a category (not just filter by one — e.g. KudosCard's tag) renders
 * the exact same look. Always the same Button, same props shape, whether or
 * not onClick is given — that's what keeps the two usages pixel-identical.
 */
export const CategoryChip = ({
  label,
  active = false,
  dotColor,
  description,
  onClick
}: CategoryChipProps) => {
  const chip = (
    <Button
      variant={active ? 'filled' : 'default'}
      size="xs"
      radius={999}
      aria-pressed={onClick ? active : undefined}
      onClick={onClick}
      leftSection={
        dotColor ? (
          <Box w={8} h={8} bdrs="50%" style={{ backgroundColor: dotColor }} />
        ) : undefined
      }
    >
      {label}
    </Button>
  )

  if (!description) return chip

  return (
    <Tooltip label={description} openDelay={300}>
      {chip}
    </Tooltip>
  )
}
